[
  {
    "id": "Desc_NuclearWaste_C",
    "index": 0,
    "name": "Uranium Waste",
    "displayName": "Uranium Waste",
    "description": "The by-product of consuming Uranium Fuel Rods in a Nuclear Power Plant.\r\nNon-Fissile Uranium can be extracted. Handle with caution.\r\n\r\nCaution: HIGHLY Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 10,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/nuclear-waste_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PlutoniumWaste_C",
    "index": 1,
    "name": "Plutonium Waste",
    "displayName": "Plutonium Waste",
    "description": "The by-product of consuming Plutonium Fuel Rods in a Nuclear Power Plant.\r\nMust be stored in a safe location. Handle with caution.\r\n\r\nCaution: EXTREMELY Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 200,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/plutonium-waste_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Cement_C",
    "index": 2,
    "name": "Concrete",
    "displayName": "Concrete",
    "description": "Used for building.\r\nGood for stable Foundations.",
    "form": "Solid",
    "sinkPoints": 12,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/concrete_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Silica_C",
    "index": 3,
    "name": "Silica",
    "displayName": "Silica",
    "description": "Derived from Raw Quartz. Commonly used to create glass structures, in advanced refinement processes, and for alternative production of electronics.",
    "form": "Solid",
    "sinkPoints": 20,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/silica_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IronPlate_C",
    "index": 4,
    "name": "Iron Plate",
    "displayName": "Iron Plate",
    "description": "Used for crafting.\r\nOne of the most basic parts.",
    "form": "Solid",
    "sinkPoints": 6,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/iron-plates_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SteelPlate_C",
    "index": 5,
    "name": "Steel Beam",
    "displayName": "Steel Beam",
    "description": "Primarily used when constructing slightly more advanced buildings.",
    "form": "Solid",
    "sinkPoints": 64,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/steel-beam_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminumIngot_C",
    "index": 6,
    "name": "Aluminum Ingot",
    "displayName": "Aluminum Ingot",
    "description": "Smelted from Aluminum Scrap, which is refined from Alumina Solution.\r\nUsed to produce specialized aluminum-based parts.",
    "form": "Solid",
    "sinkPoints": 131,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/aluminium-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Battery_C",
    "index": 7,
    "name": "Battery",
    "displayName": "Battery",
    "description": "Primarily used as fuel for Drones and vehicles.",
    "form": "Solid",
    "sinkPoints": 465,
    "sinkable": true,
    "energyValue": 6000,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/battery_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Fuel_C",
    "index": 8,
    "name": "Packaged Fuel",
    "displayName": "Packaged Fuel",
    "description": "Fuel, packaged for alternative transport. Can be used as fuel for vehicles and the Jetpack.",
    "form": "Solid",
    "sinkPoints": 270,
    "sinkable": true,
    "energyValue": 750,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=21,G=125,R=235,A=255)",
    "imagePath": "/images/game/fuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedIonizedFuel_C",
    "index": 9,
    "name": "Packaged Ionized Fuel",
    "displayName": "Packaged Ionized Fuel",
    "description": "Ionized Fuel, packaged for alternative transport. Can be used as fuel for vehicles and the Jetpack.",
    "form": "Solid",
    "sinkPoints": 5246,
    "sinkable": true,
    "energyValue": 10000,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ionized-rocket-fuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedRocketFuel_C",
    "index": 10,
    "name": "Packaged Rocket Fuel",
    "displayName": "Packaged Rocket Fuel",
    "description": "Rocket Fuel, packaged for alternative transport. Can be used as fuel for vehicles and the Jetpack.",
    "form": "Solid",
    "sinkPoints": 1028,
    "sinkable": true,
    "energyValue": 7200,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/packaged-rocket-fuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_TurboFuel_C",
    "index": 11,
    "name": "Packaged Turbofuel",
    "displayName": "Packaged Turbofuel",
    "description": "Turbofuel, packaged for alternative transport. Can be used as fuel for vehicles and the Jetpack.",
    "form": "Solid",
    "sinkPoints": 570,
    "sinkable": true,
    "energyValue": 2000,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=46,G=41,R=212,A=255)",
    "imagePath": "/images/game/turbo-fuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HazmatFilter_C",
    "index": 12,
    "name": "Iodine-Infused Filter",
    "displayName": "Iodine-Infused Filter",
    "description": "Absorbs radioactive particles when used with the Hazmat Suit.",
    "form": "Solid",
    "sinkPoints": 2274,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/hazmat-filter_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CompactedCoal_C",
    "index": 13,
    "name": "Compacted Coal",
    "displayName": "Compacted Coal",
    "description": "A much more efficient alternative to Coal. Used as fuel for vehicles and Coal-Powered Generators.",
    "form": "Solid",
    "sinkPoints": 28,
    "sinkable": true,
    "energyValue": 630,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/compacted-coal_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedOilResidue_C",
    "index": 14,
    "name": "Packaged Heavy Oil Residue",
    "displayName": "Packaged Heavy Oil Residue",
    "description": "Heavy Oil Residue, packaged for alternative transport. Can be used as fuel for vehicles.",
    "form": "Solid",
    "sinkPoints": 180,
    "sinkable": true,
    "energyValue": 400,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=120,G=45,R=109,A=255)",
    "imagePath": "/images/game/oil-residue_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PetroleumCoke_C",
    "index": 15,
    "name": "Petroleum Coke",
    "displayName": "Petroleum Coke",
    "description": "Used for crafting.\r\nA carbon-rich material distilled from Heavy Oil Residue. \r\nUsed as a less efficient Coal replacement.",
    "form": "Solid",
    "sinkPoints": 20,
    "sinkable": true,
    "energyValue": 180,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/petroleum-coke_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedOil_C",
    "index": 16,
    "name": "Packaged Oil",
    "displayName": "Packaged Oil",
    "description": "Crude Oil, packaged for alternative transport. Can be used as fuel for vehicles.",
    "form": "Solid",
    "sinkPoints": 180,
    "sinkable": true,
    "energyValue": 320,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/oil_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IronRod_C",
    "index": 17,
    "name": "Iron Rod",
    "displayName": "Iron Rod",
    "description": "Used for crafting.\r\nOne of the most basic parts.",
    "form": "Solid",
    "sinkPoints": 4,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/iron-rods_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Wire_C",
    "index": 18,
    "name": "Wire",
    "displayName": "Wire",
    "description": "Used for crafting.\r\nOne of the most basic parts.",
    "form": "Solid",
    "sinkPoints": 6,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/wire_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Cable_C",
    "index": 19,
    "name": "Cable",
    "displayName": "Cable",
    "description": "Used for crafting.\r\nPrimarily used to build Power Lines.",
    "form": "Solid",
    "sinkPoints": 24,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/cables_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IronIngot_C",
    "index": 20,
    "name": "Iron Ingot",
    "displayName": "Iron Ingot",
    "description": "Used for crafting the most basic parts.",
    "form": "Solid",
    "sinkPoints": 2,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/iron-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IronPlateReinforced_C",
    "index": 21,
    "name": "Reinforced Iron Plate",
    "displayName": "Reinforced Iron Plate",
    "description": "Used for crafting.\r\nA sturdier and more durable Iron Plate.",
    "form": "Solid",
    "sinkPoints": 120,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/reinforced-iron-plates_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Rotor_C",
    "index": 22,
    "name": "Rotor",
    "displayName": "Rotor",
    "description": "Used for crafting.\r\nThe moving parts of a motor.",
    "form": "Solid",
    "sinkPoints": 140,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/rotor_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_LiquidFuel_C",
    "index": 23,
    "name": "Fuel",
    "displayName": "Fuel",
    "description": "Can be used as-is to generate power, or packaged to be used as fuel for vehicles or the Jetpack.",
    "form": "Liquid",
    "sinkPoints": 75,
    "sinkable": true,
    "energyValue": 0.75,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=21,G=125,R=235,A=0)",
    "imagePath": "/images/game/liquid-fuel-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_RocketFuel_C",
    "index": 24,
    "name": "Rocket Fuel",
    "displayName": "Rocket Fuel",
    "description": "A high-impulse compressed gas fuel.\r\nCan be used as-is to power Fuel-Powered Generators, or packaged to be used as fuel for vehicles or the Jetpack.",
    "form": "Gas",
    "sinkPoints": 289,
    "sinkable": true,
    "energyValue": 3.6,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=26,G=37,R=189,A=0)",
    "imagePath": "/images/game/rocket-fuel-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CopperSheet_C",
    "index": 25,
    "name": "Copper Sheet",
    "displayName": "Copper Sheet",
    "description": "Used for crafting.\r\nPrimarily used for Pipelines due to its high corrosion resistance.",
    "form": "Solid",
    "sinkPoints": 24,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/copper-sheet_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ModularFrame_C",
    "index": 26,
    "name": "Modular Frame",
    "displayName": "Modular Frame",
    "description": "Used for crafting.\r\nA multipurpose building block.",
    "form": "Solid",
    "sinkPoints": 408,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/modular-frame_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IronScrew_C",
    "index": 27,
    "name": "Screws",
    "displayName": "Screws",
    "description": "Used for crafting.\r\nOne of the most basic parts.",
    "form": "Solid",
    "sinkPoints": 2,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/iron-screws_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NitricAcid_C",
    "index": 28,
    "name": "Nitric Acid",
    "displayName": "Nitric Acid",
    "description": "Produced when Nitrogen Gas reacts with Water. Its high corrosiveness and oxidizing properties make it an excellent choice for refinement and fuel production processes.",
    "form": "Liquid",
    "sinkPoints": 94,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=162,G=217,R=217,A=0)",
    "imagePath": "/images/game/nitric-acid_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_LiquidTurboFuel_C",
    "index": 29,
    "name": "Turbofuel",
    "displayName": "Turbofuel",
    "description": "A more efficient alternative to Fuel. Can be used as-is to generate power, or packaged to be used as fuel for vehicles.",
    "form": "Liquid",
    "sinkPoints": 225,
    "sinkable": true,
    "energyValue": 2,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=46,G=41,R=212,A=0)",
    "imagePath": "/images/game/liquid-turbo-fuel-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_GasTank_C",
    "index": 30,
    "name": "Empty Fluid Tank",
    "displayName": "Empty Fluid Tank",
    "description": "Used to package gases and volatile liquids for transportation.",
    "form": "Solid",
    "sinkPoints": 170,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/pressure-tank_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CrystalOscillator_C",
    "index": 31,
    "name": "Crystal Oscillator",
    "displayName": "Crystal Oscillator",
    "description": "An electronic oscillator circuit that uses the mechanical resonance of a vibrating crystal to create an electrical signal with a precise frequency.",
    "form": "Solid",
    "sinkPoints": 3072,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/crystal-oscillator_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Motor_C",
    "index": 32,
    "name": "Motor",
    "displayName": "Motor",
    "description": "Creates a mechanical force that is used to move things from machines to vehicles.",
    "form": "Solid",
    "sinkPoints": 1520,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/engine_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_DarkMatter_C",
    "index": 33,
    "name": "Dark Matter Crystal",
    "displayName": "Dark Matter Crystal",
    "description": "Concentrated Dark Matter Residue that is isolated within a crystalline vessel. This form of containment allows for utilising Dark Matter reliably in other production processes.\r\n\r\nPower Usage: 500-1500 MW (1000 MW average).",
    "form": "Solid",
    "sinkPoints": 1780,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/time-crystal_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_IonizedFuel_C",
    "index": 34,
    "name": "Ionized Fuel",
    "displayName": "Ionized Fuel",
    "description": "Fuel that has been ionized, allowing it to deliver incredible output.\r\nCan be used as-is to power Fuel-Powered Generators, or packaged to be used as fuel for vehicles or the Jetpack.",
    "form": "Gas",
    "sinkPoints": 2398,
    "sinkable": true,
    "energyValue": 5,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=26,G=95,R=213,A=60)",
    "imagePath": "/images/game/ionized-fuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ComputerSuper_C",
    "index": 35,
    "name": "Supercomputer",
    "displayName": "Supercomputer",
    "description": "The next-gen version of a Computer.",
    "form": "Solid",
    "sinkPoints": 97352,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/quantum-computer_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CoolingSystem_C",
    "index": 36,
    "name": "Cooling System",
    "displayName": "Cooling System",
    "description": "Keeps advanced parts and buildings from exceeding efficient temperature levels.",
    "form": "Solid",
    "sinkPoints": 12006,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/cooling-system_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_FicsiteMesh_C",
    "index": 37,
    "name": "Ficsite Trigon",
    "displayName": "Ficsite Trigon",
    "description": "The Ficsite Trigon, made from Ficsite Ingots, is perfectly shaped for all construction challenges. Its performance is so exceptional, it basically solved structural engineering.",
    "form": "Solid",
    "sinkPoints": 1291,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ficsite-mesh_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_MotorLightweight_C",
    "index": 38,
    "name": "Turbo Motor",
    "displayName": "Turbo Motor",
    "description": "A more complex and powerful version of the regular Motor.",
    "form": "Solid",
    "sinkPoints": 240496,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/turbo-motor_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_TimeCrystal_C",
    "index": 39,
    "name": "Time Crystal",
    "displayName": "Time Crystal",
    "description": "Time Crystals are Diamonds that have been reconfigured on a sub-atomic level in the Converter to retain a time-periodic self-organizing structure. This allows them to be used in the development of quantum processing and storage technologies.",
    "form": "Solid",
    "sinkPoints": 960,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/exotic-matter_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_DarkEnergy_C",
    "index": 40,
    "name": "Dark Matter Residue",
    "displayName": "Dark Matter Residue",
    "description": "Produced as a by-product of Quantum Encoding processes and alternatively generated in the Converter.\r\n\r\nVarious fields of science are still debating the nature and properties of Dark Matter. Meanwhile, FICSIT has found several applications for it in space-time manipulation.",
    "form": "Gas",
    "sinkPoints": 130,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=249,G=175,R=253,A=150)",
    "imagePath": "/images/game/dark-energy_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SAMIngot_C",
    "index": 41,
    "name": "Reanimated SAM",
    "displayName": "Reanimated SAM",
    "description": "The active and contained form of the Strange Alien Matter.\r\n\r\nProper electromagnetic containment is required, as it appears to be able to manipulate the atomic bonds of any matter it comes into contact with.",
    "form": "Solid",
    "sinkPoints": 160,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/reanimated-sam_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_QuantumEnergy_C",
    "index": 42,
    "name": "Excited Photonic Matter",
    "displayName": "Excited Photonic Matter",
    "description": "Excited Photonic Matter is essential for all production processes in the Quantum Encoder.\r\n\r\nFormed in the Converter by inducing intense photon interactions through exposure to SAM in a high-energy environment.",
    "form": "Gas",
    "sinkPoints": 100,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=232,G=245,R=118,A=90)",
    "imagePath": "/images/game/quantum-energy_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Diamond_C",
    "index": 43,
    "name": "Diamonds",
    "displayName": "Diamonds",
    "description": "Synthetic Diamonds produced by exposing Coal to extreme heat and pressure.\r\n\r\nUsed in the production of Time Crystals and Dark Matter Crystals.\r\n\r\nPower Usage: 250-750 MW (500 MW average).",
    "form": "Solid",
    "sinkPoints": 240,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/diamonds_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminumPlate_C",
    "index": 44,
    "name": "Alclad Aluminum Sheet",
    "displayName": "Alclad Aluminum Sheet",
    "description": "Used to make products that require high heat conduction or a high specific strength. Thin, lightweight, and highly durable.",
    "form": "Solid",
    "sinkPoints": 266,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/aluminium-sheet_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_QuantumOscillator_C",
    "index": 45,
    "name": "Superposition Oscillator",
    "displayName": "Superposition Oscillator",
    "description": "An oscillator circuit that uses the mechanical resonance of a vibrating crystal to create a string vibration with a precise frequency. Often used in teleportation technology and dimensional manipulation.",
    "form": "Solid",
    "sinkPoints": 37292,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/super-position-oscillator_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_TemporalProcessor_C",
    "index": 46,
    "name": "Neural-Quantum Processor",
    "displayName": "Neural-Quantum Processor",
    "description": "The Neural-Quantum Processor utilizes a combination of neural network architecture and quantum computing techniques to achieve unprecedented performance. This technology has enabled some of FICSIT's biggest advancements in artificial intelligence and relativistic engineering.",
    "form": "Solid",
    "sinkPoints": 248034,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/temporal-processor_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_12_C",
    "index": 47,
    "name": "AI Expansion Server",
    "displayName": "AI Expansion Server",
    "description": "Project Part #12. Ship via the Space Elevator to complete phases of Project Assembly.\r\nPower Usage: 0-2000 MW (1000 MW average).\r\n\r\nGrowth is the metric by which we measure success.",
    "form": "Solid",
    "sinkPoints": 597652,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ai-expension_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_6_C",
    "index": 48,
    "name": "Magnetic Field Generator",
    "displayName": "Magnetic Field Generator",
    "description": "Project Part #7. Ship via the Space Elevator to complete phases of Project Assembly.\r\n\r\nThese modular generators use superconducting magnets and vast amounts of electricity to produce a powerful and easily expandable magnetic field.",
    "form": "Solid",
    "sinkPoints": 11000,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/magnetic-field-generator_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SAMFluctuator_C",
    "index": 49,
    "name": "SAM Fluctuator",
    "displayName": "SAM Fluctuator",
    "description": "The SAM Fluctuator is able to regulate and direct the behavior of Reanimated SAM through the application of electric charges with varying frequencies.\r\nThis control facilitates technologies such as matter-to-energy conversion and spatiotemporal matter manipulation.",
    "form": "Solid",
    "sinkPoints": 1968,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/sam-fluctuator_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SteelPipe_C",
    "index": 50,
    "name": "Steel Pipe",
    "displayName": "Steel Pipe",
    "description": "Primarily used when constructing slightly more advanced buildings.",
    "form": "Solid",
    "sinkPoints": 24,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/steel-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ModularFrameFused_C",
    "index": 51,
    "name": "Fused Modular Frame",
    "displayName": "Fused Modular Frame",
    "description": "A corrosion-resistant, nitride-hardened, highly-robust-yet-lightweight modular frame.",
    "form": "Solid",
    "sinkPoints": 62840,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/fused-modular-frame_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ModularFrameLightweight_C",
    "index": 52,
    "name": "Radio Control Unit",
    "displayName": "Radio Control Unit",
    "description": "Enhances and directs radio signals.",
    "form": "Solid",
    "sinkPoints": 32352,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/radio-control-unit_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_FicsiteIngot_C",
    "index": 53,
    "name": "Ficsite Ingot",
    "displayName": "Ficsite Ingot",
    "description": "Produced by reconstructing other metals on a molecular level using Strange Alien Matter.\r\n\r\nSynthesized by FICSIT to be the perfect construction material, and used in the most high-end processes.",
    "form": "Solid",
    "sinkPoints": 1936,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ficsite-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_10_C",
    "index": 54,
    "name": "Biochemical Sculptor",
    "displayName": "Biochemical Sculptor",
    "description": "Project Part #10. Ship via the Space Elevator to complete phases of Project Assembly.\r\n\r\nYears ahead of the competition, this top-of-the-line 3D printer is used for the production of synthetic biological resources.",
    "form": "Solid",
    "sinkPoints": 301778,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/biochemical-sculptor_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_7_C",
    "index": 55,
    "name": "Assembly Director System",
    "displayName": "Assembly Director System",
    "description": "Project Part #6. Ship via the Space Elevator to complete phases of Project Assembly.\r\n\r\nThis extremely fast and precise computing system is specifically designed to direct the Project Assembly: Assembly Phase.",
    "form": "Solid",
    "sinkPoints": 500176,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/assembly-director-system_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_GoldIngot_C",
    "index": 56,
    "name": "Caterium Ingot",
    "displayName": "Caterium Ingot",
    "description": "Smelted from Caterium Ore. Primarily used for advanced electronics.",
    "form": "Solid",
    "sinkPoints": 42,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/caterium-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_FluidCanister_C",
    "index": 57,
    "name": "Empty Canister",
    "displayName": "Empty Canister",
    "description": "Used to package fluids for transportation.",
    "form": "Solid",
    "sinkPoints": 60,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/empty-cannister_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CircuitBoard_C",
    "index": 58,
    "name": "Circuit Board",
    "displayName": "Circuit Board",
    "description": "Advanced electronics that have a plethora of different uses.",
    "form": "Solid",
    "sinkPoints": 696,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/circuit-board_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Plastic_C",
    "index": 59,
    "name": "Plastic",
    "displayName": "Plastic",
    "description": "Versatile and easy to manufacture, this material has a wide range of uses.",
    "form": "Solid",
    "sinkPoints": 75,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/plastic_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SteelPlateReinforced_C",
    "index": 60,
    "name": "Encased Industrial Beam",
    "displayName": "Encased Industrial Beam",
    "description": "Simultaneously utilizes the compressive strength of concrete and the tensile strength of steel.\r\nMostly used as a stable base for constructing buildings.",
    "form": "Solid",
    "sinkPoints": 528,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/encased-steel-beam_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Rubber_C",
    "index": 61,
    "name": "Rubber",
    "displayName": "Rubber",
    "description": "A very flexible material that has a lot of friction.",
    "form": "Solid",
    "sinkPoints": 60,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/rubber_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PolymerResin_C",
    "index": 62,
    "name": "Polymer Resin",
    "displayName": "Polymer Resin",
    "description": "A by-product of Crude Oil refinement into Fuel. Commonly used to manufacture Plastic and Rubber.",
    "form": "Solid",
    "sinkPoints": 12,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/polymer-resin_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HeavyOilResidue_C",
    "index": 63,
    "name": "Heavy Oil Residue",
    "displayName": "Heavy Oil Residue",
    "description": "A by-product of Plastic and Rubber production. Can be further refined into Fuel and Petroleum Coke.",
    "form": "Liquid",
    "sinkPoints": 30,
    "sinkable": true,
    "energyValue": 0.4,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=120,G=45,R=109,A=0)",
    "imagePath": "/images/game/liquid-heavy-oil-residue-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_QuartzCrystal_C",
    "index": 64,
    "name": "Quartz Crystal",
    "displayName": "Quartz Crystal",
    "description": "Derived from Raw Quartz. Used in the production of advanced radar technology and high-quality display screens.",
    "form": "Solid",
    "sinkPoints": 50,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/quartz-resource_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SteelIngot_C",
    "index": 65,
    "name": "Steel Ingot",
    "displayName": "Steel Ingot",
    "description": "Smelted from a combination of Iron Ore and Coal. Can be made into several parts used in building construction.",
    "form": "Solid",
    "sinkPoints": 8,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/steel-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_2_C",
    "index": 66,
    "name": "Versatile Framework",
    "displayName": "Versatile Framework",
    "description": "Project Part #2. Ship via the Space Elevator to complete phases of Project Assembly.",
    "form": "Solid",
    "sinkPoints": 1176,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spelevator-part-2_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedWater_C",
    "index": 67,
    "name": "Packaged Water",
    "displayName": "Packaged Water",
    "description": "Water, packaged for alternative transport.",
    "form": "Solid",
    "sinkPoints": 130,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=212,G=176,R=122,A=255)",
    "imagePath": "/images/game/packaged-water_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CopperIngot_C",
    "index": 68,
    "name": "Copper Ingot",
    "displayName": "Copper Ingot",
    "description": "Used for crafting the most basic parts.",
    "form": "Solid",
    "sinkPoints": 6,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/copper-ingot_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminumScrap_C",
    "index": 69,
    "name": "Aluminum Scrap",
    "displayName": "Aluminum Scrap",
    "description": "Refined from Alumina. Can be smelted into Aluminum Ingots for industrial usage.",
    "form": "Solid",
    "sinkPoints": 27,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/aluminium-scrap_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminumCasing_C",
    "index": 70,
    "name": "Aluminum Casing",
    "displayName": "Aluminum Casing",
    "description": "A versatile container cast from Aluminum Ingots.",
    "form": "Solid",
    "sinkPoints": 393,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/aluminium-casing_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminaSolution_C",
    "index": 71,
    "name": "Alumina Solution",
    "displayName": "Alumina Solution",
    "description": "Dissolved Alumina, extracted from Bauxite. Can be further refined into Aluminum Scrap for Aluminum Ingot production.",
    "form": "Liquid",
    "sinkPoints": 20,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=193,G=193,R=193,A=0)",
    "imagePath": "/images/game/liquid-alumina-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Computer_C",
    "index": 72,
    "name": "Computer",
    "displayName": "Computer",
    "description": "A complex logic machine that is used to control advanced behavior in other machines.",
    "form": "Solid",
    "sinkPoints": 8352,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/computer_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ModularFrameHeavy_C",
    "index": 73,
    "name": "Heavy Modular Frame",
    "displayName": "Heavy Modular Frame",
    "description": "A more robust multipurpose frame.",
    "form": "Solid",
    "sinkPoints": 10800,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/modular-frame-heavy_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_1_C",
    "index": 74,
    "name": "Smart Plating",
    "displayName": "Smart Plating",
    "description": "Project Part #1. Ship via the Space Elevator to complete phases of Project Assembly.",
    "form": "Solid",
    "sinkPoints": 520,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spelevator-part-1_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HighSpeedConnector_C",
    "index": 75,
    "name": "High-Speed Connector",
    "displayName": "High-Speed Connector",
    "description": "Connects multiple cables and wires in a very efficient way. Uses a standard pattern, so it has many varied applications.",
    "form": "Solid",
    "sinkPoints": 3776,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/high-speed-connector_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_3_C",
    "index": 76,
    "name": "Automated Wiring",
    "displayName": "Automated Wiring",
    "description": "Project Part #3. Ship via the Space Elevator to complete phases of Project Assembly.",
    "form": "Solid",
    "sinkPoints": 1440,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spelevator-part-3_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Stator_C",
    "index": 77,
    "name": "Stator",
    "displayName": "Stator",
    "description": "Used for crafting.\r\nThe static parts of a motor.",
    "form": "Solid",
    "sinkPoints": 240,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/stator_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CircuitBoardHighSpeed_C",
    "index": 78,
    "name": "AI Limiter",
    "displayName": "AI Limiter",
    "description": "Controls AIs and keeps them from evolving in malicious ways. Super advanced electronics.",
    "form": "Solid",
    "sinkPoints": 920,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ai-limiter_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HighSpeedWire_C",
    "index": 79,
    "name": "Quickwire",
    "displayName": "Quickwire",
    "description": "Caterium's high conductivity and resistance to corrosion make it ideal for small, advanced electronics.",
    "form": "Solid",
    "sinkPoints": 17,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/quickwire_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_4_C",
    "index": 80,
    "name": "Modular Engine",
    "displayName": "Modular Engine",
    "description": "Project Part #4. Ship via the Space Elevator to complete phases of Project Assembly.",
    "form": "Solid",
    "sinkPoints": 9960,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spelevator-part-4_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_5_C",
    "index": 81,
    "name": "Adaptive Control Unit",
    "displayName": "Adaptive Control Unit",
    "description": "Project Part #5. Ship via the Space Elevator to complete phases of Project Assembly.",
    "form": "Solid",
    "sinkPoints": 76368,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spelevator-part-5_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PressureConversionCube_C",
    "index": 82,
    "name": "Pressure Conversion Cube",
    "displayName": "Pressure Conversion Cube",
    "description": "Converts outgoing force into internal pressure. Required to contain unstable, high-energy matter.",
    "form": "Solid",
    "sinkPoints": 255088,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/conversion-cube_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PlutoniumCell_C",
    "index": 83,
    "name": "Encased Plutonium Cell",
    "displayName": "Encased Plutonium Cell",
    "description": "Plutonium Pellets encased in concrete.\r\nUsed to produce Plutonium Fuel Rods for Nuclear Power production.\r\n\r\nPower Usage: 250-750 MW (500 MW average).\r\n﻿Caution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 120,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/encased-plutonium-cell_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PlutoniumPellet_C",
    "index": 84,
    "name": "Plutonium Pellet",
    "displayName": "Plutonium Pellet",
    "description": "Produced in the Particle Accelerator through conversion of Non-fissile Uranium.\r\nUsed to produce Encased Plutonium Cells for Plutonium Fuel Rods.\r\n\r\nPower Usage: 250-750 MW (500 MW average).\r\nCaution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 20,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/plutonium-pellet_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NonFissibleUranium_C",
    "index": 85,
    "name": "Non-Fissile Uranium",
    "displayName": "Non-Fissile Uranium",
    "description": "The Uranium-238 isotope is non-fissile, meaning it cannot be used for nuclear fission. It can, however, be converted into fissile Plutonium in the Particle Accelerator.\r\n\r\nCaution: Mildly Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0.75,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/non-fissile-uranium_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SulfuricAcid_C",
    "index": 86,
    "name": "Sulfuric Acid",
    "displayName": "Sulfuric Acid",
    "description": "Produced by combining Sulfur and Water in a complex reaction. Primarily used in refinement processes and Battery production.",
    "form": "Liquid",
    "sinkPoints": 16,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=0,G=255,R=255,A=0)",
    "imagePath": "/images/game/liquid-sulfuric-acid-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CopperDust_C",
    "index": 87,
    "name": "Copper Powder",
    "displayName": "Copper Powder",
    "description": "Ground-up Copper Ingots.\r\nThe high natural density of Copper, combined with the granularity of the powder, makes this part perfect for producing Nuclear Pasta in the Particle Accelerator.",
    "form": "Solid",
    "sinkPoints": 72,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/copper-dust_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AluminumPlateReinforced_C",
    "index": 88,
    "name": "Heat Sink",
    "displayName": "Heat Sink",
    "description": "Used to dissipate heat faster.",
    "form": "Solid",
    "sinkPoints": 2804,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/heatsink_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_ElectromagneticControlRod_C",
    "index": 89,
    "name": "Electromagnetic Control Rod",
    "displayName": "Electromagnetic Control Rod",
    "description": "Regulates power output via electromagnetism.",
    "form": "Solid",
    "sinkPoints": 2560,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/electromagnetic-control-rod_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_9_C",
    "index": 90,
    "name": "Nuclear Pasta",
    "displayName": "Nuclear Pasta",
    "description": "Project Part #9. Ship via the Space Elevator to complete phases of Project Assembly.\r\nPower Usage: 500-1500 MW (1000 MW average).\r\n\r\nNuclear Pasta is extremely dense degenerate matter, formed when extreme pressure forces protons and electrons together into neutrons. It is theorized to exist naturally within the crust of neutron stars.",
    "form": "Solid",
    "sinkPoints": 538976,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/nuclear-pasta_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_UraniumCell_C",
    "index": 91,
    "name": "Encased Uranium Cell",
    "displayName": "Encased Uranium Cell",
    "description": "Used to produce Uranium Fuel Rods for Nuclear Power production. Made from Uranium Ore.\r\n\r\nCaution: Mildly Radioactive.",
    "form": "Solid",
    "sinkPoints": 147,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0.5,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/nuclear-cell_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_DissolvedSilica_C",
    "index": 92,
    "name": "Dissolved Silica",
    "displayName": "Dissolved Silica",
    "description": "Silica dissolved in Water, produced as part of the alternative refinement of Raw Quartz.\r\nThe Silica can be extracted from the Water to complete the refinement process.",
    "form": "Liquid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=238,G=190,R=226,A=0)",
    "imagePath": "/images/game/dissolved-silica_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_8_C",
    "index": 93,
    "name": "Thermal Propulsion Rocket",
    "displayName": "Thermal Propulsion Rocket",
    "description": "Project Part #8. Ship via the Space Elevator to complete phases of Project Assembly.\r\n\r\nUses extreme heat to produce the high-pressure plasma required to get Project Assembly into motion.",
    "form": "Solid",
    "sinkPoints": 728508,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/thermal-propulsion-rocket_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Gunpowder_C",
    "index": 94,
    "name": "Black Powder",
    "displayName": "Black Powder",
    "description": "An explosive powder that is commonly used to produce simple explosives.",
    "form": "Solid",
    "sinkPoints": 14,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/gunpowder_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Ficsonium_C",
    "index": 95,
    "name": "Ficsonium",
    "displayName": "Ficsonium",
    "description": "Usage and production of this material is strictly prohibited. On Earth, that is. There are no rules in space, only efficiency. \r\n\r\nPower Usage: 500-1500 MW (1000 MW average).\r\nCaution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 250,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ficsonium-cell_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SingularityCell_C",
    "index": 96,
    "name": "Singularity Cell",
    "displayName": "Singularity Cell",
    "description": "Used to break down space and time. Required to power Portals.",
    "form": "Solid",
    "sinkPoints": 114675,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/singularity-cell_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpaceElevatorPart_11_C",
    "index": 97,
    "name": "Ballistic Warp Drive",
    "displayName": "Ballistic Warp Drive",
    "description": "Project Part #11. Ship via the Space Elevator to complete phases of Project Assembly.\r\n\r\nA large amount of force is required for the Warp Drives to activate, so sticking them to rockets was the logical next step. Additionally, results improved immensely when the observers were further removed from the Warp Drives upon activation.",
    "form": "Solid",
    "sinkPoints": 2895334,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ballistic-warp-drive_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Filter_C",
    "index": 98,
    "name": "Gas Filter",
    "displayName": "Gas Filter",
    "description": "Filters out toxins and pollutants from the air when used with a Gas Mask.",
    "form": "Solid",
    "sinkPoints": 608,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/gas-mask-filter_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AlienProtein_C",
    "index": 99,
    "name": "Alien Protein",
    "displayName": "Alien Protein",
    "description": "Ground-up Alien Remains in a neat little package.\r\nUsed for medical purposes and to research alien organisms.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/alien-protein_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Crystal_C",
    "index": 100,
    "name": "Blue Power Slug",
    "displayName": "Blue Power Slug",
    "description": "A strange slug radiating an unknown weak power.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/power-slug-green_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AlienDNACapsule_C",
    "index": 101,
    "name": "Alien DNA Capsule",
    "displayName": "Alien DNA Capsule",
    "description": "Translates organic chemicals into readable alien genetic information.\r\nUsed for researching alien organisms.\r\n\r\nGo the extra kilometer! Knowledge is power, and power is just efficiency with fewer steps. Depositing Alien DNA Capsules in the AWESOME Sink provides FICSIT with knowledge, and pioneers with Coupons.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/alien-dna_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_WAT2_C",
    "index": 102,
    "name": "Mercer Sphere",
    "displayName": "Mercer Sphere",
    "description": "A weird alien phenomenon. While the sphere appears liquid, it behaves like a solid and does not have any detectable mass. It seems to somehow interact with and have awareness of its environment.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/wat-2_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Crystal_mk3_C",
    "index": 103,
    "name": "Purple Power Slug",
    "displayName": "Purple Power Slug",
    "description": "A strange slug radiating a powerful unknown power.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/power-slug-purple_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Crystal_mk2_C",
    "index": 104,
    "name": "Yellow Power Slug",
    "displayName": "Yellow Power Slug",
    "description": "A strange slug radiating an unknown power.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/power-slug-yellow_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_GunpowderMK2_C",
    "index": 105,
    "name": "Smokeless Powder",
    "displayName": "Smokeless Powder",
    "description": "An explosive powder that is commonly used to produce modern firearms.",
    "form": "Solid",
    "sinkPoints": 58,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/gunpowder-mk-2_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_XmasStar_C",
    "index": 106,
    "name": "FICSMAS Wonder Star",
    "displayName": "FICSMAS Wonder Star",
    "description": "A symbol of appreciation for all the hard work FICSIT has done for its employees. It seems to have an aura of gratitude. Seeing this also means the seasonal event is nearly done, and we can finally get back to Saving The Day.",
    "form": "Solid",
    "sinkPoints": 6540,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/star_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBallCluster_C",
    "index": 107,
    "name": "FICSMAS Ornament Bundle",
    "displayName": "FICSMAS Ornament Bundle",
    "description": "A collection of FICSMAS ornaments and also an eyesore.",
    "form": "Solid",
    "sinkPoints": 100,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/balls_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasWreath_C",
    "index": 108,
    "name": "FICSMAS Wreath",
    "displayName": "FICSMAS Wreath",
    "description": "FICSIT's newest holiday innovation: decorations that can be turned into decorations! Efficiency and waste-conscious design at its best.",
    "form": "Solid",
    "sinkPoints": 630,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/wreath-no-bow_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_CandyCane_C",
    "index": 109,
    "name": "Candy Cane",
    "displayName": "Candy Cane",
    "description": "A delicious Candy Cane to be enjoyed during the FICSMAS Holidays.\r\n*Disclaimer: Not for human consumption...",
    "form": "Solid",
    "sinkPoints": 6,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/cane-part_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_Snow_C",
    "index": 110,
    "name": "FICSMAS Actual Snow",
    "displayName": "FICSMAS Actual Snow",
    "description": "This Actual Snow is made from several chemical elements and experiences 100% like naturally occuring snow after extensive user testing.",
    "form": "Solid",
    "sinkPoints": 5,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/snow_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBow_C",
    "index": 111,
    "name": "FICSMAS Bow",
    "displayName": "FICSMAS Bow",
    "description": "A fancy bow. Not for wearing, eating, admiring, Lizard Doggos, humans, aliens, or anything not related to FICSMAS factory production.",
    "form": "Solid",
    "sinkPoints": 4,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/bow_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBall3_C",
    "index": 112,
    "name": "Copper FICSMAS Ornament",
    "displayName": "Copper FICSMAS Ornament",
    "description": "An ornament for making FICSMAS Decorations. A slightly dignified copper.",
    "form": "Solid",
    "sinkPoints": 32,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/xmas-ball-yellow_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBall4_C",
    "index": 113,
    "name": "Iron FICSMAS Ornament",
    "displayName": "Iron FICSMAS Ornament",
    "description": "An ornament for making FICSMAS Decorations. An okay iron.",
    "form": "Solid",
    "sinkPoints": 18,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/xmas-ball-silver_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBranch_C",
    "index": 114,
    "name": "FICSMAS Tree Branch",
    "displayName": "FICSMAS Tree Branch",
    "description": "This FICSMAS Tree Branch is very different from regular tree branches: it's used to produce parts and buildings during the FICSMAS event, rather than for combustion.",
    "form": "Solid",
    "sinkPoints": 2,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/branch_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBall1_C",
    "index": 115,
    "name": "Red FICSMAS Ornament",
    "displayName": "Red FICSMAS Ornament",
    "description": "An ornament for making FICSMAS Decorations. An acceptable red.",
    "form": "Solid",
    "sinkPoints": 2,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/xmas-ball-red_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_XmasBall2_C",
    "index": 116,
    "name": "Blue FICSMAS Ornament",
    "displayName": "Blue FICSMAS Ornament",
    "description": "An ornament for making FICSMAS Decorations. A mildly pleasing blue.",
    "form": "Solid",
    "sinkPoints": 1,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/xmas-ball-blue_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_Gift_C",
    "index": 117,
    "name": "FICSMAS Gift",
    "displayName": "FICSMAS Gift",
    "description": "Gifts that have inexplicably fallen from the sky or spawned from a FICSMAS Gift Tree.\r\n\r\nDon’t question it—they’re used to produce FICSMAS buildings and parts.\r\n\r\nThese Gifts are part of the FICSMAS Event, like the calendar in the HUB.",
    "form": "Solid",
    "sinkPoints": 1,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/gift_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_NuclearFuelRod_C",
    "index": 118,
    "name": "Uranium Fuel Rod",
    "displayName": "Uranium Fuel Rod",
    "description": "Used as fuel for Nuclear Power Plants.\r\n\r\nCaution: Produces radioactive Uranium Waste when consumed.\r\nCaution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 43468,
    "sinkable": true,
    "energyValue": 750000,
    "radioactiveDecay": 50,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/nuclear-fuel-rod_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PlutoniumFuelRod_C",
    "index": 119,
    "name": "Plutonium Fuel Rod",
    "displayName": "Plutonium Fuel Rod",
    "description": "Used as fuel for Nuclear Power Plants.\r\n\r\nCaution: Produces radioactive Plutonium Waste when consumed.\r\nCaution: HIGHLY Radioactive.",
    "form": "Solid",
    "sinkPoints": 153184,
    "sinkable": true,
    "energyValue": 1500000,
    "radioactiveDecay": 250,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/plutonium-fuel-rod_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_FicsoniumFuelRod_C",
    "index": 120,
    "name": "Ficsonium Fuel Rod",
    "displayName": "Ficsonium Fuel Rod",
    "description": "Used as fuel for Nuclear Power Plants.\r\nThe power source that put FICSIT on the map. Literally. The crater is still there.\r\n\r\nCaution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 150000,
    "radioactiveDecay": 1000,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/ficsonium-fuel-rod_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Rebar_Explosive_C",
    "index": 121,
    "name": "Explosive Rebar",
    "displayName": "Explosive Rebar",
    "description": "Explodes on impact, dealing heavy damage.",
    "form": "Solid",
    "sinkPoints": 360,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/exp-rebar_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Rebar_Stunshot_C",
    "index": 122,
    "name": "Stun Rebar",
    "displayName": "Stun Rebar",
    "description": "Electrocutes the target on impact, stunning it for a short time.\r\n\r\nStun Duration: 5 seconds",
    "form": "Solid",
    "sinkPoints": 186,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/stun-rebar_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CartridgeSmartProjectile_C",
    "index": 123,
    "name": "Homing Rifle Ammo",
    "displayName": "Homing Rifle Ammo",
    "description": "The bullet guidance system built into this ammunition allows it to accurately hit any target within the reticle area.\r\nEspecially useful when dealing with agile threats, or for pioneers who can't be bothered to aim properly.",
    "form": "Solid",
    "sinkPoints": 855,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/homing-rifle_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NobeliskCluster_C",
    "index": 124,
    "name": "Cluster Nobelisk",
    "displayName": "Cluster Nobelisk",
    "description": "Detonates into multiple smaller explosions. Practical for clearing out large areas of vegetation and other inconveniences.",
    "form": "Solid",
    "sinkPoints": 1376,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/cluster_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NobeliskExplosive_C",
    "index": 125,
    "name": "Nobelisk",
    "displayName": "Nobelisk",
    "description": "A simple explosive, useful for clearing boulders, vegetation, and other obstacles.",
    "form": "Solid",
    "sinkPoints": 152,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/explosive_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NobeliskGas_C",
    "index": 126,
    "name": "Gas Nobelisk",
    "displayName": "Gas Nobelisk",
    "description": "Creates a deadly gas cloud instead of a regular explosion.",
    "form": "Solid",
    "sinkPoints": 544,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/gas_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NobeliskNuke_C",
    "index": 127,
    "name": "Nuke Nobelisk",
    "displayName": "Nuke Nobelisk",
    "description": "Uses a nuclear fission reaction to generate a massive explosion.\r\nWARNING: Ensure all FICSIT property is clear of the blast zone before detonation.\r\n",
    "form": "Solid",
    "sinkPoints": 19600,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/nuke_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NobeliskShockwave_C",
    "index": 128,
    "name": "Pulse Nobelisk",
    "displayName": "Pulse Nobelisk",
    "description": "Generates a powerful shockwave instead of a regular explosion.",
    "form": "Solid",
    "sinkPoints": 1533,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/shock_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Fireworks_Projectile_01_C",
    "index": 129,
    "name": "Sweet Fireworks",
    "displayName": "Sweet Fireworks",
    "description": "Has the minimum safety requirements.",
    "form": "Solid",
    "sinkPoints": 60,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/fireworks-01_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_Fireworks_Projectile_02_C",
    "index": 130,
    "name": "Fancy Fireworks",
    "displayName": "Fancy Fireworks",
    "description": "Poses acceptable amount of risk to pioneers.",
    "form": "Solid",
    "sinkPoints": 40,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/fireworks-02_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_Fireworks_Projectile_03_C",
    "index": 131,
    "name": "Sparkly Fireworks",
    "displayName": "Sparkly Fireworks",
    "description": "Keep away from easily distracted pioneers.",
    "form": "Solid",
    "sinkPoints": 32,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/fireworks-03_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_SnowballProjectile_C",
    "index": 132,
    "name": "Snowball",
    "displayName": "Snowball",
    "description": "Compressed dihydrogen monoxide crystals for weaponized fun!",
    "form": "Solid",
    "sinkPoints": 30,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/snowball-projectile_256.png",
    "isFicsmas": true
  },
  {
    "id": "Desc_SpikedRebar_C",
    "index": 133,
    "name": "Iron Rebar",
    "displayName": "Iron Rebar",
    "description": "Can be shot using the Rebar Gun for self-defense purposes.",
    "form": "Solid",
    "sinkPoints": 8,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/rebar_256.png",
    "isFicsmas": false
  },
  {
    "id": "BP_ItemDescriptorPortableMiner_C",
    "index": 134,
    "name": "Portable Miner",
    "displayName": "Portable Miner",
    "description": "Automatically extracts a resource when placed on a resource node.\r\nNote: Has limited storage space.",
    "form": "Solid",
    "sinkPoints": 56,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/portable-miner_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Rebar_Spreadshot_C",
    "index": 135,
    "name": "Shatter Rebar",
    "displayName": "Shatter Rebar",
    "description": "Fractures when shot, launching deadly debris with wide spread but limited range.",
    "form": "Solid",
    "sinkPoints": 332,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/scatter-rebar_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CartridgeChaos_C",
    "index": 136,
    "name": "Turbo Rifle Ammo",
    "displayName": "Turbo Rifle Ammo",
    "description": "Lightweight, compact, and volatile. These rounds provide extreme capacity and rate of fire at the cost of accuracy.",
    "form": "Solid",
    "sinkPoints": 120,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/turbo-rifle_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CartridgeStandard_C",
    "index": 137,
    "name": "Rifle Ammo",
    "displayName": "Rifle Ammo",
    "description": "Standard issue Rifle ammunition, useful for establishing dominance.",
    "form": "Solid",
    "sinkPoints": 25,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/rifle_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_OreIron_C",
    "index": 138,
    "name": "Iron Ore",
    "displayName": "Iron Ore",
    "description": "Used for crafting.\r\nThe most essential basic resource.",
    "form": "Solid",
    "sinkPoints": 1,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/iron-new_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Coal_C",
    "index": 139,
    "name": "Coal",
    "displayName": "Coal",
    "description": "Mainly used as fuel for vehicles & Coal-Powered Generators, or in Steel production.",
    "form": "Solid",
    "sinkPoints": 3,
    "sinkable": true,
    "energyValue": 300,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/coal-ore_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Water_C",
    "index": 140,
    "name": "Water",
    "displayName": "Water",
    "description": "It's water.",
    "form": "Liquid",
    "sinkPoints": 5,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=212,G=176,R=122,A=0)",
    "imagePath": "/images/game/liquid-water-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_NitrogenGas_C",
    "index": 141,
    "name": "Nitrogen Gas",
    "displayName": "Nitrogen Gas",
    "description": "Has a variety of uses, including metallurgy, cooling, and Nitric Acid production. On MASSAGE-2 (AB)b, it can be extracted from underground gas wells.",
    "form": "Gas",
    "sinkPoints": 10,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=89,G=89,R=89,A=0)",
    "imagePath": "/images/game/nitrogen-gas_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Sulfur_C",
    "index": 142,
    "name": "Sulfur",
    "displayName": "Sulfur",
    "description": "Primarily used to produce Black Powder.",
    "form": "Solid",
    "sinkPoints": 11,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/sulfur_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SAM_C",
    "index": 143,
    "name": "SAM",
    "displayName": "SAM",
    "description": "Strange Alien Matter, commonly referred to as SAM, doesn't seem to follow the known laws of physics. It whispers of new possibilities.",
    "form": "Solid",
    "sinkPoints": 20,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/same-ore_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_OreBauxite_C",
    "index": 144,
    "name": "Bauxite",
    "displayName": "Bauxite",
    "description": "Used to produce Alumina, which can be further refined into the Aluminum Scrap required to produce Aluminum Ingots.",
    "form": "Solid",
    "sinkPoints": 8,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/bauxite_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_OreGold_C",
    "index": 145,
    "name": "Caterium Ore",
    "displayName": "Caterium Ore",
    "description": "Smelted into Caterium Ingots, which are primarily used for advanced electronics.",
    "form": "Solid",
    "sinkPoints": 7,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/caterium-ore_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_OreCopper_C",
    "index": 146,
    "name": "Copper Ore",
    "displayName": "Copper Ore",
    "description": "Used for crafting.\r\nA basic resource primarily used for electricity.",
    "form": "Solid",
    "sinkPoints": 3,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/copper-new_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_RawQuartz_C",
    "index": 147,
    "name": "Raw Quartz",
    "displayName": "Raw Quartz",
    "description": "Can be processed into Quartz Crystals and Silica, which both offer a variety of applications.",
    "form": "Solid",
    "sinkPoints": 15,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/quartz-crystal_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Stone_C",
    "index": 148,
    "name": "Limestone",
    "displayName": "Limestone",
    "description": "Used for crafting.\r\nA basic resource primarily used for stable Foundations.",
    "form": "Solid",
    "sinkPoints": 2,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/stone_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_OreUranium_C",
    "index": 149,
    "name": "Uranium",
    "displayName": "Uranium",
    "description": "A radioactive element. \r\nUsed to produce Encased Uranium Cells for Uranium Fuel Rods.\r\n\r\nCaution: Moderately Radioactive.",
    "form": "Solid",
    "sinkPoints": 35,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 15,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/uranium-ore_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_LiquidOil_C",
    "index": 150,
    "name": "Crude Oil",
    "displayName": "Crude Oil",
    "description": "Refined into all kinds of Oil-based resources, like Fuel and Plastic.",
    "form": "Liquid",
    "sinkPoints": 30,
    "sinkable": true,
    "energyValue": 0.32,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=25,G=0,R=25,A=0)",
    "imagePath": "/images/game/liquid-oil-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Biofuel_C",
    "index": 151,
    "name": "Solid Biofuel",
    "displayName": "Solid Biofuel",
    "description": "The most energy-efficient form of solid Biomass. Can be used as fuel for the Chainsaw.",
    "form": "Solid",
    "sinkPoints": 48,
    "sinkable": true,
    "energyValue": 450,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/solid-biofuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedBiofuel_C",
    "index": 152,
    "name": "Packaged Liquid Biofuel",
    "displayName": "Packaged Liquid Biofuel",
    "description": "Liquid Biofuel, packaged for alternative transport. Can be used as fuel for vehicles and the Jetpack.",
    "form": "Solid",
    "sinkPoints": 370,
    "sinkable": true,
    "energyValue": 750,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=42,G=83,R=58,A=255)",
    "imagePath": "/images/game/liquid-biofuel_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_GenericBiomass_C",
    "index": 153,
    "name": "Biomass",
    "displayName": "Biomass",
    "description": "Primarily used as fuel.\r\nBiomass Burners and vehicles can use it for power.\r\nBiomass is much more energy-efficient than raw biological matter.",
    "form": "Solid",
    "sinkPoints": 12,
    "sinkable": true,
    "energyValue": 180,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/biomass-final_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Leaves_C",
    "index": 154,
    "name": "Leaves",
    "displayName": "Leaves",
    "description": "Primarily used as fuel.\r\nBiomass Burners and vehicles can use Leaves for power.",
    "form": "Solid",
    "sinkPoints": 3,
    "sinkable": true,
    "energyValue": 15,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/leaves_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Mycelia_C",
    "index": 155,
    "name": "Mycelia",
    "displayName": "Mycelia",
    "description": "Used for crafting.\r\nBiomass Burners and vehicles can also use Mycelia for power.",
    "form": "Solid",
    "sinkPoints": 10,
    "sinkable": true,
    "energyValue": 20,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/mycelia_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Wood_C",
    "index": 156,
    "name": "Wood",
    "displayName": "Wood",
    "description": "Primarily used as fuel.\r\nBiomass Burners and vehicles can use Wood for power.",
    "form": "Solid",
    "sinkPoints": 30,
    "sinkable": true,
    "energyValue": 100,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/wood_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_LiquidBiofuel_C",
    "index": 157,
    "name": "Liquid Biofuel",
    "displayName": "Liquid Biofuel",
    "description": "Liquid Biofuel can be used as-is to generate power, or packaged to be used as fuel for vehicles.",
    "form": "Liquid",
    "sinkPoints": 261,
    "sinkable": true,
    "energyValue": 0.75,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=44,G=83,R=59,A=0)",
    "imagePath": "/images/game/liquid-biofuel-pipe_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedAlumina_C",
    "index": 158,
    "name": "Packaged Alumina Solution",
    "displayName": "Packaged Alumina Solution",
    "description": "Alumina Solution, packaged for alternative transport.",
    "form": "Solid",
    "sinkPoints": 160,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=42,G=83,R=58,A=255)",
    "imagePath": "/images/game/packaged-alumina-solution_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedNitrogenGas_C",
    "index": 159,
    "name": "Packaged Nitrogen Gas",
    "displayName": "Packaged Nitrogen Gas",
    "description": "Nitrogen Gas, packaged for alternative transport.",
    "form": "Solid",
    "sinkPoints": 312,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=42,G=83,R=58,A=255)",
    "imagePath": "/images/game/packaged-nitrogen_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedNitricAcid_C",
    "index": 160,
    "name": "Packaged Nitric Acid",
    "displayName": "Packaged Nitric Acid",
    "description": "Nitric Acid, packaged for alternative transport.",
    "form": "Solid",
    "sinkPoints": 412,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=42,G=83,R=58,A=255)",
    "imagePath": "/images/game/packaged-nitric-acid_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_PackagedSulfuricAcid_C",
    "index": 161,
    "name": "Packaged Sulfuric Acid",
    "displayName": "Packaged Sulfuric Acid",
    "description": "Sulfuric Acid, packaged for alternative transport.",
    "form": "Solid",
    "sinkPoints": 152,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=42,G=83,R=58,A=255)",
    "imagePath": "/images/game/pckaged-sulphuric-acid_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_Fabric_C",
    "index": 162,
    "name": "Fabric",
    "displayName": "Fabric",
    "description": "Used to craft equipment.\r\nFlexible but durable fabric.",
    "form": "Solid",
    "sinkPoints": 140,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/fabric_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HogParts_C",
    "index": 163,
    "name": "Hog Remains",
    "displayName": "Hog Remains",
    "description": "The carapace of an alien Hog creature.\r\nUsed for MAM research.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/hog-part_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_SpitterParts_C",
    "index": 164,
    "name": "Spitter Remains",
    "displayName": "Spitter Remains",
    "description": "The remains of a plasma-spitting alien creature.\r\nUsed for MAM research.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/spitter-part_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_StingerParts_C",
    "index": 165,
    "name": "Stinger Remains",
    "displayName": "Stinger Remains",
    "description": "The remains of whatever that creepy thing was.\r\nUsed for MAM research.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/stinger-part_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_HatcherParts_C",
    "index": 166,
    "name": "Hatcher Remains",
    "displayName": "Hatcher Remains",
    "description": "The shell-like remains of an alien... thing.\r\nUsed for MAM research.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/hatcher-part_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_CrystalShard_C",
    "index": 167,
    "name": "Power Shard",
    "displayName": "Power Shard",
    "description": "Power Slug mucus compressed into a solid crystal-like shard. \r\nIt radiates a strange power.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/power-shard_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_WAT1_C",
    "index": 168,
    "name": "Somersloop",
    "displayName": "Somersloop",
    "description": "An odd alien object with a mind-bending, yet somehow familiar shape. It emits an unsettling energy.",
    "form": "Solid",
    "sinkPoints": 0,
    "sinkable": false,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": false,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/wat-1_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_AlienPowerFuel_C",
    "index": 169,
    "name": "Alien Power Matrix",
    "displayName": "Alien Power Matrix",
    "description": "This intricate condensed-matter matrix is used to enhance the output of the Alien Power Augmenter.\r\n\r\nInitially developed in efforts to create a human-made Somersloop, the Alien Power Matrix cannot sustain the extra-dimensional energy connection on its own. However, it can effectively stabilize the energy stream of the Somersloop.",
    "form": "Solid",
    "sinkPoints": 210,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/alien-power-matrix_256.png",
    "isFicsmas": false
  },
  {
    "id": "Desc_DroneTransport_C",
    "index": 170,
    "name": "Drone",
    "displayName": "Drone",
    "description": "Transports available input back and forth between its home Port and destination Ports. Drone Status and other details can be viewed at a Drone's home Port.\r\nMust be built on a Drone Port.\r\n\r\nHas 9 inventory slots.\r\n\r\nCan use any fuel type.\r\nRefuels at any of its connected Ports if possible.",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/drone_256.png",
    "isFicsmas": false,
    "isVehicle": true
  },
  {
    "id": "Desc_FreightWagon_C",
    "index": 171,
    "name": "Freight Car",
    "displayName": "Freight Car",
    "description": "Attaches to an Electric Locomotive or other Freight Car to transport resources. Must be built on a Railway.\r\nResources are loaded and unloaded at Freight Platforms.\r\nHas a 1600 m³ or 32-slot capacity, depending on whether resources are liquid or solid.",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/freight-car_256.png",
    "isFicsmas": false,
    "isVehicle": true
  },
  {
    "id": "Desc_Locomotive_C",
    "index": 172,
    "name": "Electric Locomotive",
    "displayName": "Electric Locomotive",
    "description": "Moves Freight Cars from station to station.\r\nRequires between 25-110 MW of power to move. \r\nMust be built on a Railway.\r\n\r\nNicknamed 'Leif' by FICSIT pioneers because of its reliability.",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/locomotive_256.png",
    "isFicsmas": false,
    "isVehicle": true
  },
  {
    "id": "Desc_Truck_C",
    "index": 173,
    "name": "Truck",
    "displayName": "Truck",
    "description": "Picks up and delivers resources at Truck Stations. This process can be automated. Nicknamed 'The Unit' by FICSIT pioneers because of its massive frame.\r\n\r\nHas 48 inventory slots and a built-in Crafting Bench.\r\n\r\nFuel: Any fuel type",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/truck_256.png",
    "isFicsmas": false,
    "isVehicle": true
  },
  {
    "id": "Desc_Tractor_C",
    "index": 174,
    "name": "Tractor",
    "displayName": "Tractor",
    "description": "Picks up and delivers resources at Truck Stations. This process can be automated. Nicknamed 'Sugarcube' by FICSIT pioneers with the justification “It’s pretty sweet, y’know”.\r\n\r\nHas 25 inventory slots and a built-in Crafting Bench.\r\n\r\nFuel: Any fuel type",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/tractor_256.png",
    "isFicsmas": false,
    "isVehicle": true
  },
  {
    "id": "Desc_Explorer_C",
    "index": 175,
    "name": "Explorer",
    "displayName": "Explorer",
    "description": "Traverses rough terrain, including near-vertical surfaces. A fast and nimble exploration vehicle.\r\n\r\nHas 12 inventory slots and a built-in Crafting Bench.\r\n\r\nFuel: Any fuel type",
    "form": "Invalid",
    "sinkPoints": null,
    "sinkable": true,
    "energyValue": 0,
    "radioactiveDecay": 0,
    "canBeDiscarded": true,
    "color": "(B=255,G=255,R=255,A=0)",
    "imagePath": "/images/game/explorer_256.png",
    "isFicsmas": false,
    "isVehicle": true
  }
]